import React from 'react';
import { EnvironmentVariables } from '../../../helpers/constants/EnvironmentVariables';
import './Indicator.scss';

const componentInfo = {
  name: 'Indicator',
  className: 'indicator',
  useType: 'ContentPiece',
  componentType: 'ThirdParty',
};

const Indicator = ({ loading }: { loading: boolean }) => {
  return (
    <div className={`${componentInfo.className} ${loading ? 'is-loading' : 'not-loading'}`}>
      <div
        className={`spinner face front`}
        style={{
          backgroundImage: `radial-gradient(circle at 65% 15%, rgb(219, 40, 49, 0.2), rgb(0, 0, 0, 0.6)), url(${EnvironmentVariables.OyakLogoPng})`,
        }}></div>
      <div
        className={`spinner face back`}
        style={{
          backgroundImage: `radial-gradient(circle at 65% 15%, rgb(219, 40, 49, 0.2), rgb(0, 0, 0, 0.6)), url(${EnvironmentVariables.OyakLogoPng})`,
        }}></div>
    </div>
  );
};

export default Indicator;
